"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateToEpochSeconds_1 = __importDefault(require("./dateToEpochSeconds"));
const math_1 = require("./math");
function updateLastStudied(aggregatedStat, timeFinished) {
    if (!timeFinished) {
        return aggregatedStat.lastStudied;
    }
    const currentLastStudied = aggregatedStat && aggregatedStat.lastStudied;
    const newLastStudied = (0, dateToEpochSeconds_1.default)(new Date(timeFinished));
    return (0, math_1.getMaximumValue)(currentLastStudied, newLastStudied);
}
exports.default = updateLastStudied;
